// extracted by mini-css-extract-plugin
export default {"titleStyle":"AllEntregasSt_titleStyle__JAYAK","contentEnt":"AllEntregasSt_contentEnt__VbD+Z"};